var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper-section" },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.showLog
        ? _c("WrapperDocRef", {
            attrs: { title: _vm.$t("message.refdoclog") },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("BaseSectionDocRefLog", {
                        attrs: {
                          createButtonText: _vm.$t("button.addlog"),
                          logs: _vm.mapLogs,
                          refDoc: _vm.refDoc,
                          refId: _vm.refId
                        },
                        on: {
                          onToggleStatus: _vm.handleClickToggleStatusLog,
                          onEdit: _vm.handleClickEditLog,
                          onDelete: _vm.handleClickDeleteLog,
                          onCreate: _vm.handleClickCreateLog
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3957310392
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.showAttachFile
        ? _c("WrapperDocRef", {
            attrs: { title: _vm.$t("message.refdocfile") },
            scopedSlots: _vm._u(
              [
                {
                  key: "content",
                  fn: function() {
                    return [
                      _c("BaseSectionDocRefFile", {
                        attrs: {
                          images: _vm.mapImages,
                          otherFiles: _vm.mapOtherFiles,
                          uploadingImages: _vm.mapUploadingImages,
                          uploadingOtherFiles: _vm.mapUploadingOtherFile,
                          createButtonText: _vm.$t("button.upload")
                        },
                        on: {
                          onUploadFile: _vm.handleUploadFile,
                          onDelete: _vm.handleClickDeleteFile
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              3663064685
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("WrapperDocRef", {
        attrs: { title: _vm.$t("message.refdocactivity") },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function() {
              return [
                _c("BaseSectionDocRefActivity", {
                  attrs: { activities: _vm.mapActivities }
                })
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("BaseModalDocRefLog", {
        attrs: {
          id: _vm.MODAL_FORM_LOG,
          isSubmitted: _vm.isSubmittedFormLog,
          initialValue: _vm.initialValueLog,
          logTopics: _vm.logTopics
        },
        on: { onSubmit: _vm.handleSubmitFormLog }
      }),
      _vm._v(" "),
      _c("baseConfirmDeleteModal", {
        attrs: {
          show: _vm.modalConfirmDelete.show,
          loading: _vm.modalConfirmDelete.loading
        },
        on: {
          onClose: _vm.handleCloseConfirmDelete,
          onCancel: _vm.handleCancleConfirmDelete,
          onSubmit: _vm.handleSumitConfirmDelete
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e44e08a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e44e08a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/combine/DocRef.vue
// module id = null
// module chunks = 